import { useMemo } from 'react';
import { FormicaSelectBoxItem } from '../custom/FormicaSearchSelectBox';
import { toCanonicalDashboardChartId, toDashboardChartLabel } from '../../util/dashboardEmailChartId';

function useDashboardEmailCharts(
  dashboardChartIds: string[],
  dashboardKey: string | undefined,
  selectedChartIds: string[]
): { options: FormicaSelectBoxItem[]; selectedItems: FormicaSelectBoxItem[] } {
  const options = useMemo(() => {
    const uniqueIds = Array.from(new Set(dashboardChartIds.filter((chartId) => chartId.trim() !== '')));
    return uniqueIds.map((chartId) => ({
      label: toDashboardChartLabel(chartId, dashboardKey),
      value: chartId,
    }));
  }, [dashboardChartIds, dashboardKey]);

  const selectedItems = useMemo(() => {
    const optionById = new Map(options.map((option) => [option.value, option]));
    const resolved: FormicaSelectBoxItem[] = [];
    selectedChartIds.forEach((savedId) => {
      const canonicalId = toCanonicalDashboardChartId(savedId);
      const option = optionById.get(savedId) ?? optionById.get(canonicalId);
      if (option != undefined && !resolved.some((item) => item.value === option.value)) {
        resolved.push(option);
      }
    });
    return resolved;
  }, [options, selectedChartIds]);

  return { options, selectedItems };
}

export default useDashboardEmailCharts;
